import { StringBufAggsBasic } from './getHistoAndBasicAggs.types';

export function checkUtf16(
	aggs: StringBufAggsBasic,
	partialData = false
): false | 'utf16be' | 'utf16le' {
	// Check for UTF-16 (without BOM)
	if (aggs.length >= 2 && (aggs.length % 2 === 0 || partialData)) {
		if (aggs.numNulls >= 0.25 * aggs.length) {
			const nullCounts = [aggs.nulls[0] + aggs.nulls[2], aggs.nulls[1] + aggs.nulls[3]];

			if (nullCounts[0] > 2 * nullCounts[1]) {
				return 'utf16be';
			} else if (nullCounts[1] > 2 * nullCounts[0]) {
				return 'utf16le';
			}
		}
	}

	return false;
}
